<template>
  <v-card>
    <v-card-title>
      {{ $t("participant.live.positionUnavailable.locationUnavailableTitle") }}
    </v-card-title>
    <v-card-text>
      <v-icon>mdi-alert</v-icon>
      {{ $t("participant.live.positionUnavailable.locationUnavailableText") }}
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="continueClick" color="secondary" text>{{
        $t("participant.live.positionUnavailable.close")
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ParticipantChallengePositionUnavailable",
  methods: {
    continueClick() {
      this.$emit("continue");
    },
  },
};
</script>

<style scoped></style>
